export const ADMIN = 'ADMIN'
export const JANITOR = 'JANITOR'
